var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Q2",
    "data-name": "icons Q2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.144,
    height: 26.146,
    viewBox: "0 0 26.144 26.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25328",
    "data-name": "Path 25328",
    d: "M28.244,4.1H5.966A1.9,1.9,0,0,0,4,6V28.343a1.9,1.9,0,0,0,1.966,1.9H28.244a1.9,1.9,0,0,0,1.9-1.9V6A1.9,1.9,0,0,0,28.244,4.1ZM11.8,26.378H7.866V13.928H11.8ZM9.832,12.224A2.293,2.293,0,0,1,7.6,9.931a2.228,2.228,0,0,1,4.456,0A2.293,2.293,0,0,1,9.832,12.224ZM26.278,26.378H22.412V20.284c0-1.442,0-3.276-2.031-3.276s-2.293,1.573-2.293,3.211v6.159H14.222V13.928h3.669v1.7h.066A4.063,4.063,0,0,1,21.626,13.6c3.931,0,4.652,2.555,4.652,5.963Z",
    transform: "translate(-4 -4.098)",
    fill: "#E6E7EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInGrey);
export default __webpack_public_path__ + "static/media/LinkedInGrey.ead0bae54bbbcc223cddabccebba30dd.svg";
export { ForwardRef as ReactComponent };